import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Icon from '../../Icons'

const PayBadge = ({ ticketNumber }) => {
  const { t } = useTranslation(['parking'])
  const navigate = useNavigate()

  const navigateToPayment = () => {
    navigate(`/parking/${ticketNumber}/payment`)
  }

  return (
    <div className="pay-badge">
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Icon
          icon="cross"
          styles={{ marginRight: '10px', width: '22px', height: '22px' }}
          svgProps={{ fill: '#CE2C21' }}
        />
        <div>{t('parking:notPaid')}</div>
      </div>
      <button onClick={navigateToPayment} className="button button-red inverted-colors">
        {t('parking:pay')}
      </button>
    </div>
  )
}

PayBadge.propTypes = {
  ticketNumber: PropTypes.string,
}

export default PayBadge
